import { useTranslation } from 'react-i18next'
import { ComputeEstimatedPaymentResultDto } from '@applyonline/shared'
import { hasFlexPromotion } from '../../../data/credit-application-selectors'

interface Props {
  estimatedPayment: ComputeEstimatedPaymentResultDto | null
  minInterestRate: number
  hasCoapplicant: boolean
  maxLoanTerm: number
  useNewConsentFlow: boolean
  displayFooter2?: boolean
}

const ApprovedSoftHitAndHardHitFooter = ({
  estimatedPayment,
  minInterestRate,
  hasCoapplicant,
  maxLoanTerm,
  useNewConsentFlow,
  displayFooter2 = true,
}: Props) => {
  const { t } = useTranslation()
  const isPromotional = estimatedPayment?.isPromotional ?? false
  const interestRate = estimatedPayment?.interestRate ?? minInterestRate
  const lenderFeeNotice =
    isPromotional && estimatedPayment?.borrowerFeeRate === 0 ? '' : t('prequalification.priorToQualifyNotes.lenderFeeNotice')

  const promotext =
    estimatedPayment && hasFlexPromotion(estimatedPayment)
      ? t('prequalification.priorToQualifyNotes.promoReducedRateDurationPartOfLoan', {
          interestRate: estimatedPayment.regularRate,
          reducedRateDurationInMonths: estimatedPayment.promoDurationMonths,
        })
      : ''

  const interestRateQualified = isPromotional
    ? t('prequalification.priorToQualifyNotes.promotionalCodeQualifiedInterestRate')
    : t('prequalification.priorToQualifyNotes.clientQualifedInterestRate')
  const footerOne = t('prequalification.priorToQualifyNotes.1', {
    term: maxLoanTerm,
    interestRate,
    lenderFeeNotice,
    promotext,
    interestRateQualified,
  })
  const footerTwo = t(
    hasCoapplicant
      ? 'prequalification.priorToQualifyNotes.creditReportWithCoapplicant'
      : 'prequalification.priorToQualifyNotes.creditReport',
  )

  return (
    <div style={{ borderTop: '1px solid black', marginTop: '5rem' }}>
      <span style={{ fontSize: '1.25rem', lineHeight: '1.45rem' }}>
        {useNewConsentFlow ? (
          <p style={{ marginTop: '2rem' }}>
            <span style={{ color: 'red' }}>¹</span>
            {footerOne} {displayFooter2 && footerTwo}
          </p>
        ) : (
          <>
            <p style={{ marginTop: '2rem' }}>
              <span style={{ color: 'red' }}>¹</span>
              {footerOne}
            </p>
            <p style={{ marginTop: '2rem' }}>
              <span style={{ color: 'red' }}>²</span>
              {footerTwo}
            </p>
          </>
        )}
      </span>
    </div>
  )
}
export default ApprovedSoftHitAndHardHitFooter
